import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  description: {
    textAlign: 'center',
    color: theme.palette.brand.greenNature,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    whiteSpace: 'break-spaces',
  },
  headerDescription: {
    marginBottom: 0,
    marginTop: theme.spacing(1.5),
    fontWeight: 500,
    fontSize: 18,
    lineHeight: `${theme.spacing(3)}px`,
    color: theme.palette.brand.blackOpacityToGrey,
  },
}));

export default function Description({
  description,
  isInHeader = false,
}: {
  description: string | React.ReactNode;
  isInHeader?: boolean;
}) {
  const classes = useStyles();
  return (
    <Typography
      className={`${classes.description} ${
        isInHeader ? classes.headerDescription : ''
      }`}
      variant="body2"
    >
      {description}
    </Typography>
  );
}
